var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke:#f8f8f8;stroke-miterlimit:10;stroke-width:4px;}.d{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 64,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 59.992,
    height: 40.921,
    rx: 8,
    transform: "translate(2.004 16.903)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9.738,
    height: 8.889,
    rx: 2,
    transform: "translate(26.94 30.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M31.082,8.7a4.956,4.956,0,0,1,5.045-4.849H51.013A4.955,4.955,0,0,1,56.057,8.7V12h4.009V8.7A8.893,8.893,0,0,0,51.013,0H36.126a8.893,8.893,0,0,0-9.053,8.7V12h4.009Z",
    transform: "translate(-11.569 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 24.936,
    y1: 7.82,
    transform: "translate(2.004 27.091)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 7.82,
    x2: 24.936,
    transform: "translate(36.937 27.091)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWork);
export default __webpack_public_path__ + "static/media/icon_work.81dbfe0e27546305137b058bbc436ee6.svg";
export { ForwardRef as ReactComponent };